import { render } from "./picking-message.vue?vue&type=template&id=4d8d8054"
import script from "./picking-message.vue?vue&type=script&lang=js"
export * from "./picking-message.vue?vue&type=script&lang=js"

import "./picking-message.vue?vue&type=style&index=0&id=4d8d8054&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__